import {
  SectionAccountInformation,
  SectionExpenseIncome,
  SectionPreLoan,
} from './components/forms/financial';
import {
  SectionDomicile,
  SectionIdentityPhoto,
  SectionPersonalContact,
  SectionPersonalData,
} from './components/forms/personal-identity';
import {
  SectionBiologicalFamily,
  SectionCloseFamily,
} from './components/forms/family-information';
import Review from './components/forms/review';
import Financial from './components/forms/financial';
import PersonalIdentity from './components/forms/personal-identity';
import FamilyInformation from './components/forms/family-information';

export const ApplicationForms = [
  PersonalIdentity,
  FamilyInformation,
  Financial,
  Review,
];

export const UserInformationReview = [
  {
    id: 1,
    title: 'Identitas Diri',
    children: (
      <>
        <SectionIdentityPhoto readonly />
        <SectionPersonalData readonly />
        <SectionDomicile readonly />
        <SectionPersonalContact readonly />
      </>
    ),
  },
  {
    id: 2,
    title: 'Informasi Keluarga Kandung',
    children: (
      <>
        <SectionCloseFamily readonly />
        <SectionBiologicalFamily readonly />
      </>
    ),
  },
  {
    id: 3,
    title: 'Penghasilan & Pengeluaran',
    children: (
      <>
        <SectionExpenseIncome readonly />
        <SectionAccountInformation readonly />
      </>
    ),
  },
  {
    id: 4,
    title: 'Pinjaman yang Dipilih',
    children: <SectionPreLoan readonly />,
  },
];
